import { render, staticRenderFns } from "./Agricola.vue?vue&type=template&id=84d8cd4e&scoped=true&lang=pug"
import script from "./Agricola.vue?vue&type=script&lang=js"
export * from "./Agricola.vue?vue&type=script&lang=js"
import style0 from "./Agricola.vue?vue&type=style&index=0&id=84d8cd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d8cd4e",
  null
  
)

export default component.exports